"use strict";
if (!Array.prototype.forEach) {
    Array.prototype.forEach = function (fn) {
        for (var i = 0; i < this.length; i++) {
            fn(this[i], i, this);
        }
    };
}
//# sourceMappingURL=array-foreach.js.map